import isEqual from 'lodash/isEqual.js';
import kebabCase from 'just-kebab-case';

function hasAnalyticsDirective(node) {
  if (!node) {
    return false;
  }
  return node.elm.nodeType === 1 && node.data.directives && node.data.directives.some(directive => directive.name === 'pendo-analytics');
}
function getType(_ref) {
  let {
    value,
    arg
  } = _ref;
  const type = typeof value;
  if (type === 'string') {
    return arg;
  }
  if (value && type === 'object') {
    return value.type;
  }
  return false;
}
function getValue(value) {
  const type = typeof value;
  if (type === 'string') {
    return value;
  }
  if (value && type === 'object') {
    return value.value;
  }
  return false;
}
function applyAttributes(el) {
  let {
    value,
    type
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (type) {
    el.setAttribute('pendo-analytics', `${type}:${kebabCase(value)}`);
    return;
  }
  el.setAttribute('pendo-analytics', kebabCase(value));
}
function inserted(el, _ref2, vnode) {
  let {
    value,
    arg
  } = _ref2;
  if (vnode.isRootInsert && vnode.parent && hasAnalyticsDirective(vnode.parent)) {
    return;
  }
  const boundValue = getValue(value);
  const type = getType({
    value,
    arg
  });
  if (!boundValue) {
    return;
  }
  applyAttributes(el, {
    value: boundValue,
    type
  });
}
function update(el, _ref3, vnode) {
  let {
    oldValue,
    value,
    arg
  } = _ref3;
  if (vnode.isRootInsert && vnode.parent && hasAnalyticsDirective(vnode.parent)) {
    return;
  }
  if (isEqual(oldValue, value)) {
    return;
  }
  const boundValue = getValue(value);
  const type = getType({
    value,
    arg
  });
  if (!boundValue) {
    return;
  }
  applyAttributes(el, {
    value: boundValue,
    type
  });
}
function install(Vue) {
  if (install.installed) {
    return;
  }
  install.installed = true;
  Vue.directive('pendo-analytics', PendoAnalytics);
}
const PendoAnalytics = {
  inserted,
  update,
  install
};
var PendoAnalytics$1 = PendoAnalytics;

export { PendoAnalytics, applyAttributes, PendoAnalytics$1 as default, getType, getValue, inserted, install, update };
//# sourceMappingURL=pendo-analytics.js.map
